import { getToken } from '../util/storage';

const DIAGS_URL = process.env.REACT_APP_DIAGS_URL || '/api/vehicle-diags';

async function fetchWithAuth(url, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    throw new Error('Unauthorized');
  }

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Request failed');
  }

  return response.json();
}

export async function getActiveDiagnostics(vehicleId) {
  return fetchWithAuth(`${DIAGS_URL}/vehicles/${vehicleId}/diagnostics/active`);
}
